import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button } from "react-bootstrap";

export default function MessageModal(props) {
    const { t } = useTranslation();
    const [show, setShow] = useState(props.show);

    const handleClose = () => props.handleClose();

    useEffect(() => {
        setShow(props.show);
    }, [props]);

    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("MESSAGE_MODAL.WARNING")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.params.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant='warning' onClick={handleClose}>
                        {t("BUTTONS.CANCEL")}
                    </Button>
                    <Button
                        variant='primary'
                        onClick={() => {
                            handleClose();
                            props.callBack(props.params);
                        }}>
                        {t("DELETE_MODAL.OK")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}